export class Payment {

    public relations = ['user'];

    public names = {
        // therapist_id: function (data) {
        //     // return data.address && data.address.offname;
        // },
        user_id: function(data){
            if(!data.user){
                return 'нет';
            }
            return data.user.f + ' ' + data.user.i + ' '  + data.user.o;
        },
    }
}
